module.exports = "/images/creditCardCvc.svg?b5213fd17b8f80d075b63bd93ff44872";